import Vue from 'vue';
import Store from 'Services/Store';
import { capitalize } from 'filters/text';
import parsePhoneNumber from 'libphonenumber-js';

Vue.filter('shortName', function (value) {
    if (typeof value == 'string') {
        let splitName = value.split(' ');
        splitName[splitName.length - 1] = splitName[splitName.length - 1].substring(0, 1);
        return splitName.join(' ') + '.';
    } else {
        return value;
    }
});

Vue.filter('capitalize', capitalize);

Vue.filter('upperCase', function (value) {
    if (!value) return '';
    return value.toString().toUpperCase();
});

Vue.filter('lowerCase', function (value) {
    if (!value) return '';
    return value.toString().toLowerCase();
});

Vue.filter('shortText', function (value, size) {
    if (typeof value == 'string' && size != undefined) {
        if (size == 'big' && value.length > 256)
            return value.substring(0, value.lastIndexOf(' ', 256)) + '...';
        else return value;
    } else {
        if (typeof value == 'string' && value.length > 88) {
            return value.substring(0, value.lastIndexOf(' ', 88)) + '...';
        } else {
            return value;
        }
    }
});

Vue.filter('stripTags', function (value) {
    let cleanString = value.replace(/<\/?[^>]+(>|$)/g, '');
    return cleanString;
});

export var dateFormatter = function (timestamp, format, showRelativeDate = true) {
    let lang = window.App.lang;
    let dateformat = Store.get('corp').timeformat;
    let time24 = Store.get('corp').hourformat == '24';
    let timezone = Store.get('user').timezone;

    moment().locale(lang);
    moment.tz.setDefault(timezone);
    let momentDate = moment.unix(timestamp);
    if (!momentDate.isValid()) {
        momentDate = moment(timestamp);
    }

    let time = time24 ? 'HH:mm' : 'hh:mm a';
    let timeSec = time24 ? 'HH:mm:ss' : 'hh:mm:ss a';
    let mouth = 'MMMM';
    let shortMouth = 'MMM';
    let shortDate = dateformat == 'dmy' ? 'D ' + shortMouth + ' YYYY' : shortMouth + ' D, YYYY';
    let date = dateformat == 'dmy' ? 'D ' + mouth + ' YYYY' : mouth + ' D, YYYY';
    let slashedDate = dateformat == 'dmy' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
    let dashedDate = dateformat == 'dmy' ? 'DD-MM-YYYY' : 'MM-DD-YYYY';
    let today = window.i18n.gettext('Aujourd’hui');
    let tomorrow = window.i18n.gettext('Demain');
    let yesterday = window.i18n.gettext('Hier');

    let formatDate = function (momentDate, formatDate, formatTime, showRelativeDate) {
        if (formatTime) {
            formatTime = ' ' + formatTime;
        } else {
            formatTime = '';
        }

        if (!showRelativeDate) {
            var result = momentDate.format(formatDate + formatTime);
        } else {
            var result = momentDate.calendar(null, {
                sameDay: '[' + today + ']' + formatTime,
                nextDay: '[' + tomorrow + ']' + formatTime,
                nextWeek: formatDate + formatTime,
                lastDay: '[' + yesterday + ']' + formatTime,
                lastWeek: formatDate + formatTime,
                sameElse: formatDate + formatTime,
            });
        }

        if (!time24) {
            result = result.replace(/(pm|am)/i, (l) => l.toLowerCase());
        }

        return result;
    };

    switch (format) {
        case 'TIME':
            return formatDate(momentDate, time, false, false);
        case 'TIME_SEC':
            return formatDate(momentDate, timeSec, false, false);
        case 'SHORT_MONTH':
            return formatDate(momentDate, shortMouth + ' YYYY', false, false);
        case 'NORMAL_MONTH':
            return formatDate(momentDate, mouth + ' YYYY', false, false);
        case 'SLASHED_DATE':
            return formatDate(momentDate, slashedDate, false, showRelativeDate);
        case 'DASHED_DATE':
            return formatDate(momentDate, dashedDate, false, showRelativeDate);
        case 'SHORT_DATE':
            return formatDate(momentDate, shortDate, false, showRelativeDate);
        case 'NORMAL_DATE':
            return formatDate(momentDate, date, false, showRelativeDate);
        case 'NORMAL_DATE_WITH_DAY':
            return formatDate(momentDate, 'dddd ' + date, false, showRelativeDate);
        case 'SLASHED_DATE_TIME':
            return formatDate(momentDate, slashedDate, time, showRelativeDate);
        case 'SHORT_DATE_TIME':
            return formatDate(momentDate, shortDate, time, showRelativeDate);
        case 'NORMAL_DATE_TIME':
            return formatDate(momentDate, date, time, showRelativeDate);
        case 'NORMAL_DATE_TIME_WITH_DAY':
            return formatDate(momentDate, 'dddd ' + date, time, showRelativeDate);
        case 'SLASHED_DATE_TIME_SEC':
            return formatDate(momentDate, slashedDate, timeSec, showRelativeDate);
        case 'DASHED_DATE_TIME_SEC':
            return formatDate(momentDate, dashedDate, timeSec, showRelativeDate);
        case 'SHORT_DATE_TIME_SEC':
            return formatDate(momentDate, shortDate, timeSec, showRelativeDate);
        case 'NORMAL_DATE_TIME_SEC':
            return formatDate(momentDate, date, timeSec, showRelativeDate);
        default:
            throw new Error('Invalid date format: ' + format);
    }
};

Vue.filter('dateFormatter', dateFormatter);
Vue.filter(
    'dateIntervalFormatter',
    function (timestampStart, timestampEnd, format, showRelativeDate = true) {
        let dateStart = dateFormatter(timestampStart, format, showRelativeDate);
        let dateEnd = dateFormatter(timestampEnd, format, showRelativeDate);

        if (dateStart == dateEnd) {
            return [dateStart];
        }

        let matchStart = dateStart.match(/^(.+) ([0-9]{2}:.+)$/);
        let matchEnd = dateEnd.match(/^(.+) ([0-9]{2}:.+)$/);
        if (matchStart !== null && matchEnd !== null && matchStart[1] == matchEnd[1]) {
            return [dateStart, matchEnd[2], true];
        } else {
            return [dateStart, dateEnd, false];
        }
    },
);

var numberTransformer = function (value, numberFormat, withCurrency) {
    // define default
    if (!value || value.NaN) value = 0;
    if (!!withCurrency) numberFormat.currency = numberFormat.currencysymbol;

    return !withCurrency
        ? NumberFormat.formatToDisplay(value, numberFormat)
        : NumberFormat.formatToDisplayWithCurrency(value, numberFormat);
};

Vue.filter('numberformatWithOptions', function (value, forceOptions, withCurrency) {
    if (forceOptions === undefined) {
        forceOptions = {};
    }
    // override just for current method
    let numberFormat = Object.assign({}, App.numformat);
    if (Object.keys(forceOptions).length > 0) {
        Object.assign(numberFormat, forceOptions);
    }

    return numberTransformer(value, numberFormat, withCurrency);
});

Vue.filter('numberformat', function (value, displayCurrency) {
    return numberTransformer(value, App.numformat, displayCurrency);
});

Vue.filter('numberformatCurrency', function (value) {
    return numberTransformer(value, App.numformat, true);
});

Vue.filter('numberformatCurrencyCustomNumberFormat', function (value, numberFormat) {
    return numberTransformer(value, { ...App.numformat, ...numberFormat }, true);
});

Vue.filter('saasDateFormatted', function (value) {
    const date = moment(value);
    if (Store.get('corp').timeformat == 'dmy') {
        return date.format('DD/MM/YYYY');
    }
    return date.format('MM/DD/YYYY');
});

Vue.filter('creditCard', function (lastNumbers, placeholder, nbChars) {
    if (placeholder == undefined) {
        placeholder = 'x';
    }
    if (nbChars == undefined) {
        nbChars = 16;
    }

    return lastNumbers
        .padStart(nbChars, placeholder)
        .match(/.{1,4}/g)
        .join(' ');
});

Vue.filter('floatNumber', function (value) {
    return value / 100;
});

Vue.filter('fromNowCustom', function (datetime) {
    let lang = window.App.lang;
    let dateformat = Store.get('corp').timeformat;
    let time24 = Store.get('corp').hourformat == '24';
    let timezone = Store.get('user').timezone;

    moment().locale(lang);
    moment.tz.setDefault(timezone);

    let momentDate = moment(datetime).utc(true);
    let momentDateUnix = momentDate.unix();
    let now = moment();
    let diffInMinutes = now.diff(momentDate, 'minutes');
    let todayStart = moment().startOf('day').unix();
    let todayEnd = moment().endOf('day').unix();
    let yesterdayStart = moment().subtract(1, 'days').startOf('day').unix();
    let yesterdayEnd = moment().subtract(1, 'days').endOf('day').unix();

    if (diffInMinutes < 1) {
        return window.i18n.__('Il y a quelque secondes');
    } else if (diffInMinutes < 59) {
        return window.i18n.n__(
            'Il y a environ %s minute',
            'Il y a environ %s minutes',
            parseInt(diffInMinutes),
            parseInt(diffInMinutes),
        );
    } else if (momentDateUnix >= todayStart && momentDateUnix <= todayEnd) {
        let diffInHours = now.diff(momentDate, 'hours');
        return window.i18n.n__(
            'Il y a %s heure',
            'Il y a %s heures',
            parseInt(diffInHours),
            parseInt(diffInHours),
        );
    } else if (momentDateUnix >= yesterdayStart && momentDateUnix <= yesterdayEnd) {
        return window.i18n.__('Hier - %(time)s', {
            time: momentDate.hours() + ':' + momentDate.minutes(),
        });
    } else {
        return momentDate.format('dddd DD MMMM - HH:mm');
    }
});

Vue.filter('booleanFilter', function (boolean) {
    return boolean ? window.i18n.__('Oui') : window.i18n.__('Non');
});

const formatPhoneNumberEnum = Object.freeze({
    NATIONAL: 'national',
    INTERNATIONAL: 'international',
});
export const formatPhoneNumber = (value, format = formatPhoneNumberEnum.NATIONAL) => {
    try {
        format = Store.get('corp')?.phoneFormat ?? format;
        const phoneNumber = parsePhoneNumber(value);
        return format === formatPhoneNumberEnum.NATIONAL
            ? phoneNumber.formatNational()
            : phoneNumber.formatInternational();
    } catch {
        return value;
    }
};

Vue.filter('formatPhoneNumber', formatPhoneNumber);
